import useFetch from '@hooks/useFetch';

export const getLevelDisplayInfo = () =>
  'v1/users/educator-levels-display-config/';

const useLevelDisplayInfo = (
  options = { selector: null, fallbackData: undefined }
) => {
  const key = getLevelDisplayInfo();

  const {
    data: levelsDisplayInfo,
    isValidating,
    ...rest
  } = useFetch(key, {}, { fallbackData: options.fallbackData });

  if (options.selector && typeof options.selector === 'function')
    return options.selector(levelsDisplayInfo || []);
  return {
    key,
    levelsDisplayInfo,
    isValidating,
    ...rest
  };
};

export default useLevelDisplayInfo;
